export const CONTAINER_ID = 'org-selector-container';

export const POPOVER_POSITIONS: ['top'] = ['top'];

export const POPOVER_CONFIG = {
  boundaryInset: 12,
  padding: 12,
} as const;

/** Show search input when the number of other orgs meets or exceeds this value. */
export const SEARCH_THRESHOLD = 6;

/** Max height (px) of the scrollable org list inside the popover. */
export const ORG_LIST_MAX_HEIGHT_PX = 350;
